import { FlexContainer } from '@taxdown/piccolo-web';
import styled from 'styled-components';

export const QuizInitialContainer = styled(FlexContainer)`
  background: ${({ theme: { system } }) => system.background.fds_sys_color_background_selected};
  height: 85%;
`;
export const QuizInitialContent = styled(FlexContainer)`
  max-width: 480px;
  padding: ${({ theme }) => theme.reference.dimension_16};
`;

export const ButtonContainer = styled(FlexContainer)`
  background: ${({ theme: { system } }) => system.background.fds_sys_color_background_primary};
  height: 72px;
`;
